import React, { useState, useEffect, useRef } from "react";
import CustomButton from "./CustomButton";
import deleteIcon from "../assets/deleteIcon.png";
import MenuScreen from "./MenuScreen";
import ModalScreen from "./ModalScreen";
// import { fetchContent } from "../services/api";
import DeleteProfileIcon from "../assets/Delete-icon.png";
import MyProfile from "./MyProfile";
import AddProfile from "./AddProfile";
import EditProfile from "./EditProfile";
import { Translate } from "./LanguageChanger";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import backIcon from "../assets/back-button.png";
import Wrapper from "./shared/Wrapper";
import { getUserProfile, updateUserProfile } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

const DeleteProfile = ({ navigate, isLogedIn }) => {
  const [selectedElementIndex, setSelectedElementIndex] = useState(0);
  const [state, setState] = useState({
    isEditSelected: false,
    isDeleteSelected: false,
    shouldCloseMenu: true,
    shouldShowModal: false,
    shouldShowAuthModal: false,
    isBackButtonSelected: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
    updateData: "",
  });
  const {
    isEditSelected,
    isDeleteSelected,
    shouldCloseMenu,
    shouldShowModal,
    isBackButtonSelected,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    shouldShowAuthModal,
    updateData,
  } = state;

  const [screen, setScreen] = useState("DeleteProfile");
  const [data, setData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
    window.removeEventListener("keydown", DeleteProfileKeyHandler);
  };

  let user_details = JSON.parse(
    localStorage.getItem("user_details")
  ).user_profiles;

  const updatedMyprofile = localStorage.getItem("updateMyProfile")
    ? JSON.parse(localStorage.getItem("updateMyProfile")).data
    : null;

  const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  const defaultProfiles = user_profile.filter(
    (profile) => profile.is_default !== 1
  );
  const modalCANCELButtonHandler = () => {
    // MenuScreen.ReseTfocus(-1);,sh
    console.log("modalCANCELButtonHandler...",shouldCloseMenu,shouldShowModal);
   
     window.addEventListener("keydown", DeleteProfileKeyHandler);
    setState((prevState) => ({
      ...prevState,
       shouldCloseMenu: true,
      shouldShowModal: false,
    }));
    MenuScreen.ReseTfocus(1);
    setSelectedElementIndex(0);
  };
 
  const [profiles, setProfiles] = useState(
    defaultProfiles.map((profile) => ({
      name: profile.username,
      image: profile.profile,
      isKids: profile.is_kid,
      profileId: profile.profile_id,
    }))
  );

  const profileRefs = useRef([]);
  profileRefs.current = profiles.map(
    (_, i) => profileRefs.current[i] ?? React.createRef()
  );

  const addProfileRef = useRef(null);
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);

  const DeleteProfileKeyHandler = (event) => {
    // if (shouldShowModal || shouldShowAuthModal) return;
    if (event.keyCode !== undefined) {
      switch (event.keyCode) {
        case 13: // Enter key
          if (isBackButtonSelected) {
            handleBackButton();
            return;
          }
          if (selectedElementIndex < profiles.length) {
            // Determine visible profiles (exclude current active profile)
            const currentMyProfileId = JSON.parse(localStorage.getItem("myProfile"))?.profileId;
            const visibleProfilesLocal = profiles.filter(
              (p) => p.profileId !== currentMyProfileId
            );
            const profileToDelete = visibleProfilesLocal[selectedElementIndex];
            if (profileToDelete) {
              window.removeEventListener("keydown", DeleteProfileKeyHandler);
              localStorage.setItem("DeleteProfile", JSON.stringify(profileToDelete));
              if (localStorage.getItem("DeleteProfile")) {
                handleLogout();
              }
            }
          } else if (selectedElementIndex === profiles.length) {
            navigate("AddProfile"); // Navigate to add profile page
          } else if (selectedElementIndex === profiles.length + 1) {
            navigate("EditProfile");
            // Handle Edit Profile action
          } else if (selectedElementIndex === profiles.length + 2) {
          }
          break;
        case 39: // Right arrow
          if (selectedElementIndex < visibleProfiles.length - 1) {
            console.log("Right arrow pressed...", selectedElementIndex, profiles, visibleProfiles);
            setSelectedElementIndex((prevIndex) => prevIndex + 1);
          }
          break;
        case 37: // Left arrow
         if(selectedElementIndex===0){
               setState((prevState) => ({
                      ...prevState,
                      shouldShowFocus: false,
                      shouldCloseMenu: false,
                      shouldAddEventListener: false,
                    }));
                    
                                MenuScreen.SetFocus(false)
                }
          if (selectedElementIndex > 0) {
            setSelectedElementIndex((prevIndex) => prevIndex - 1);
          }
          break;
        case 38: // Up arrow
          if (!isBackButtonSelected) {
            // Back button ko select kar, profile se focus hata
            setState((prevState) => ({
              ...prevState,
              isBackButtonSelected: true,
            }));
            setSelectedElementIndex(null); 
          }
          if (selectedElementIndex === profiles.length + 1) {
            // setState((prevState) => ({
            //   ...prevState,
            //   isEditSelected: false,
            //   isDeleteSelected: false,
            // }));
            profileRefs.current.focus();
            setSelectedElementIndex(profiles.length);
            // setState({ isEditSelected: false, isDeleteSelected: false });
          } else if (selectedElementIndex === profiles.length + 2) {
            // editButtonRef.current.focus();
            setSelectedElementIndex(profiles.length + 1);
            // setState((prevState) => ({
            //   ...prevState,
            //   isEditSelected: true,
            //   isDeleteSelected: false,
            // }));
            // setState({ isEditSelected: true, isDeleteSelected: false });
          } else if (selectedElementIndex === profiles.length) {
            profileRefs.current[profiles.length - 1].current.focus();
            setSelectedElementIndex(profiles.length - 1);
          }

          break;
        case 40: // Down arrow
          if (isBackButtonSelected) {
            setState((prevState) => ({
              ...prevState,
              isBackButtonSelected: false,
            }));
            setSelectedElementIndex(0);
            return; 
          }
          // if (selectedElementIndex < profiles.length) {
          //   // profileRefs.current[selectedElementIndex].current.blur();
          //   setSelectedElementIndex(profiles.length + 1);
          //   // setState((prevState) => ({
          //   //   ...prevState,
          //   //   isEditSelected: true,
          //   //   isDeleteSelected: false,
          //   // }));
          //   // setState({ isEditSelected: true, isDeleteSelected: false });
          // } else if (selectedElementIndex === profiles.length) {
          //   addProfileRef.current.blur();
          //   setSelectedElementIndex(profiles.length + 1);
          //   // setState((prevState) => ({
          //   //   ...prevState,
          //   //   isEditSelected: true,
          //   //   isDeleteSelected: false,
          //   // }));
          //   // setState({ isEditSelected: true, isDeleteSelected: false });
          // } else if (selectedElementIndex === profiles.length + 1) {
          //   // setState((prevState) => ({
          //   //   ...prevState,
          //   //   isEditSelected: false,
          //   //   isDeleteSelected: true,
          //   // }));
          //   // setState({ isEditSelected: false, isDeleteSelected: true });
          //   setSelectedElementIndex(profiles.length + 2);
          // }
          break;
        case 461:
          handleBackButton(); // return key
          // callBack("Back");
          break;
        case 8:
          handleBackButton();
          break;
        case 10009:
          handleBackButton();
          break;
        default:
          break;
      }

      if (
        !isBackButtonSelected &&
        selectedElementIndex < profiles.length &&
        profileRefs.current[selectedElementIndex].current
      ) {
        profileRefs.current[selectedElementIndex].current.focus();
      } else if (
        selectedElementIndex === profiles.length &&
        addProfileRef.current
      ) {
        addProfileRef.current.focus();
      } else if (
        selectedElementIndex === profiles.length + 1 &&
        editButtonRef.current
      ) {
        editButtonRef.current.focus();
      } else if (
        selectedElementIndex === profiles.length + 2 &&
        deleteButtonRef.current
      ) {
        deleteButtonRef.current.focus();
      }
    }
  };

  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };

  const handleRightButton = () => {
    // First, update the state
    // setSelectedElementIndex(0);
    // document.getElementById("profile_0").focus();
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
    }));

    // Then perform DOM operations and other actions outside the state update
    MenuScreen.SetFocus(true);
  };

  // const deleteProfile = () =>{
  //   window.removeEventListener("keydown", DeleteProfileKeyHandler);
  //   localStorage.setItem(
  //     "DeleteProfile",
  //     JSON.stringify(profiles[`${selectedElementIndex}`])
  //   );
  //   if (localStorage.getItem("DeleteProfile")) {
  //     handleLogout();
  //   }
  // }

  const deleteProfile = (index) => {
    window.removeEventListener("keydown", DeleteProfileKeyHandler);

    // Accept either a profile object or an index. Prefer profile object.
    if (!index) return;
    const profileObj = typeof index === "object" ? index : profiles[index];
    if (profileObj) {
      localStorage.setItem("DeleteProfile", JSON.stringify(profileObj));
      handleLogout();
    } else {
      console.error("Profile not found for index:", index);
    }
  };

  const modalOKButtonHandler = () => {
    // Do not remove the stored DeleteProfile here - we need it when
    // `loadData` builds the delete request. `updateloadData` will
    // clear `DeleteProfile` after a successful server response.
    loadData();
  };



  const handleExit = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Yes", "No"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleBackButton = () => {
    window.removeEventListener("keydown", DeleteProfileKeyHandler);
    navigate("ProfileScreen");
  };

   const handleLogoutMenu = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleLogout = (p) => {
    console.log("handleLogout...");
    const deleteProfileName =
      JSON.parse(localStorage.getItem("DeleteProfile"))?.name || "Unknown";
    const deleteBtn = <Translate langKey={"Delete"} />;
    const cancelBtn = <Translate langKey={"Cancel"} />;
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: false,
      shouldShowModal: true,
      errTitle: "Delete-Profile",
      errDescription:"delete_account_desc", 
      // errTitle: <Translate langKey={'Delete'}/>,
      //   errDescription: <>
      //   <Translate langKey={'delete_account_desc'} />
      //   {` ${deleteProfileName}`}
      // </>,
      errIcon: DeleteProfileIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Delete", "Cancel"],
    }));
    // MenuScreen.SetFocus(true);
  };

  useEffect(() => {
    // window.addEventListener("keydown", DeleteProfileKeyHandler);
     if(shouldCloseMenu){
      window.addEventListener("keydown", DeleteProfileKeyHandler);
  }
    return () => {
      window.removeEventListener("keydown", DeleteProfileKeyHandler);
    };
  }, [selectedElementIndex, isBackButtonSelected,shouldCloseMenu]);

 const loadData = async () => {
  const getCountry = localStorage.getItem("country");
  let myHeaders = {
    platform: "0",
    iskid: "0",
    age: "12",
    country: getCountry,
    Langid: "1",
    timestamp: "0000000000",
    Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
    "Content-Type": "application/json",
  };

  // Read the profile to delete from localStorage (set by click or Enter key)
  const deletedProfile = JSON.parse(localStorage.getItem("DeleteProfile")) || {};
  const raw = {
    profile_id: deletedProfile.profileId,
    activity: 3,
    username: deletedProfile.name,
    profile: deletedProfile.image,
    is_kid: deletedProfile.isKids === 1 ? 1 : 0,
  };

  let body = JSON.stringify(raw);

  try {
    const response = await updateUserProfile(raw);

    if (response.statusCode === 200) {
      // 1. Close the modal immediately
      setState((prevState) => ({
        ...prevState,
        shouldShowModal: false,
      }));

      // 2. Show the success message
      setErrorMessage(<Translate langKey={"delete_profile_success"} />);
      sendTestMatomoEvent({
        eventCategory: "Profile",
        eventAction: "Delete",
        eventName: `${raw?.profile_id}/${raw?.username}/${raw.is_kid === 0 ? "Child" : "Adult"}`,
      });

      // 3. After a delay, navigate and clear the message
      setTimeout(() => {
        setErrorMessage("");
        updateloadData(); // This will navigate to ProfileScreen
      }, 2000); // Show message for 2 seconds
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

  const updateloadData = async () => {
    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");
    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",

      timestamp: "0000000000",
      // profileid: user_details["user_profiles"][0]["profile_id"],
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     `/V1/getUserProfile/lastupdated/0000000000/userId/${userId}`,
      //     "GET",
      //     myHeaders
      //   )
      // ]);

      const response = await getUserProfile(userId);

      localStorage.setItem("updateMyProfile", JSON.stringify(response));
      if (response.statusCode === 200) {
        localStorage.removeItem("DeleteProfile");
        window.addEventListener("keydown", DeleteProfileKeyHandler);
        navigate("ProfileScreen");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const styles = {
    container: {
         backgroundImage: `url(${solidbackgroundimg})`,
         // textAlign: "center",
         color: "white",
         backgroundColor: "#000",
         height: "100vh",
         display: "flex",
         flexDirection: "column",
         backgroundSize: "cover",
         backgroundRepeat: "no-repeat",
         // justifyContent: "center",
         // alignItems: "center",
        
       },
    profileDeleted: {
      color: "white",
      fontSize: "30px",
      padding: "0",
      position: "relative",
      margin: "0 auto",
      marginTop: "6rem",

      
    },
    profilesContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      
    },
    profileCard: {
      backgroundColor: "#0E1653",
      borderRadius: "10px",
      // padding: "10px",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // border: "7px solid white",
      width: "141px",
      height: "141px",
      border: "none",
      
      // margin: "0px",
      // padding: "0px",
      // boxSizing: "border-box",
      
    },
    profileName: {
      margin: "0px",
      padding: "0px",
      marginTop: "0px",
      fontFamily: "Anek Latin",
      fontWeight: 500,
      fontSize: "20px",
      position:"relative",
      top: "10px",
      // marginTop: "20px",
    },
    kidsBadge: {
      backgroundColor: "#ffcc00",
      borderRadius: "5px",
      padding: "0px 8px",
      marginLeft: "0px",
      position:"relative",
      bottom:"45px",
    
    },
    addProfile: {
      backgroundColor: "#4c4c4c",
      justifyContent: "center",
    },
    addProfileIcon: {
      fontSize: "50px",
    },
    focusStyle: {
      // border: "2px solid red",
      border: "2px solid rgba(255, 255, 255, 1)",
    },
    buttonStyle: {
      backgroundColor: "orange",
      border: "none",
      padding: "10px 20px",
      margin: "5px",
      borderRadius: "5px",
      cursor: "pointer",
      outline: "none",
    },
    deleteButtonStyle: {
      backgroundColor: "#ff4040",
    },
  };

  const deleteCont = {
    position: "absolute",
   top:"125px",
    opacity: "1",
   
  };

  if (screen === "MyProfile") {
    window.removeEventListener("keydown", DeleteProfileKeyHandler);
    return <MyProfile navigate={navigateToScreen} />;
  } else if (screen === "AddProfile") {
    window.removeEventListener("keydown", DeleteProfileKeyHandler);
    return <AddProfile navigate={navigateToScreen} />;
  } else if (screen === "EditProfile") {
    window.removeEventListener("keydown", DeleteProfileKeyHandler);
    return <EditProfile navigate={navigateToScreen} />;
  }

  const myProfileId = JSON.parse(localStorage.getItem("myProfile"))?.profileId;

  // ✅ Filter out the current profile before mapping
  const visibleProfiles = profiles.filter(
    (profile) => profile.profileId !== myProfileId
  );
  return (
    
    <div style={styles.container}>
      <div style={{ position: "absolute" }}>
        <Wrapper
          as="button"
          style={{
            backgroundColor: "transparent",
            border: "none",
            marginLeft: "6rem",
            borderRadius: "1rem",
            aspectRatio: "1/1",
            cursor: "pointer",
            position: "relative",
            top: "4rem",
            zIndex: "1",
            // left: "6rem",
            outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
          }}
          onMouseEnter={() => {
            // MOUSE LOGIC: Back button select karo, profiles deselect karo
            setState((prev) => ({ ...prev, isBackButtonSelected: true }));
            setSelectedElementIndex(null);
          }}
          onClick={(e) => {
            handleBackButton();
            // handleBack();
            // handleClick(null, -2);
          }}
        >
          <img src={backIcon} width={50} height={50} />
        </Wrapper>
      </div>
      <div
        style={{
          alignContent: "center",
          alignItems: "centre",
          textAlign: "center",
          position: "relative",
          top: "30%",
        }}
      >
        <h1 
         style={{
          fontFamily: "Anek Latin",
          fontWeight: 500,
          fontSize: "2rem",
          position: "relative",
          bottom: "17vh"
         }}
        >
          <Translate langKey={"Delete-Profile"} />
        </h1>
        
        <div style={styles.profilesContainer}>
          {visibleProfiles.map((profile, index) => {
            const myProfileId = JSON.parse(localStorage.getItem("myProfile"))?.profileId;
            if (myProfileId === profile.profileId) {
              return null;
            }

            return (
              <Wrapper
                style={
                  selectedElementIndex === index && !isBackButtonSelected
                    ? { ...styles.profileCard, ...styles.focusStyle }
                    : styles.profileCard
                }
                key={index}
                tabIndex={0}
                onClick={() => deleteProfile(profile)}
                ref={profileRefs.current[index]}
                id={`profile_${index}`}
                // Added for magic remote hover issue 02/10/25 check if works
                onMouseEnter={() => {
                  setState((prev) => ({ ...prev, isBackButtonSelected: false }));
                  setSelectedElementIndex(index);
                }}
              >
                <div style={deleteCont}>
                  <img src={deleteIcon} alt="delete" />
                </div>
                <img
                  src={profile.image}
                  alt={profile.name}
                  style={{
                    width: "142px",
                    height: "142px",
                    borderRadius: "10px",
                     opacity: "0.18",
                  }}
                />
                <div style={styles.profileName}>
                     {profile.name.length > 6
                    ? profile.name.slice(0, 6) + "..."
                    : profile.name}
                </div>
                <div style={styles.profileName}>
               
                  {profile.isKids === 1 && (
                    <span style={styles.kidsBadge}>KIDS</span>
                  )}
                </div>
              </Wrapper>
            );
          })}
          {/* {profiles.length < 5 && (
          <div
            style={
              selectedElementIndex === profiles.length
                ? {
                    ...styles.profileCard,
                    ...styles.addProfile,
                    ...styles.focusStyle,
                  }
                : { ...styles.profileCard, ...styles.addProfile }
            }
            onClick={addProfile}
            ref={addProfileRef}
            tabIndex={0}
          >
            <div style={styles.addProfileIcon}>+</div>
            <div style={styles.profileName}>Add Profile</div>
          </div>
        )} */}
        </div>
        {errorMessage && <p style={styles.profileDeleted}>{errorMessage}</p>}
      </div>
      {/* <div style={{ marginTop: "20px" }}></div> */}
      <div style={{ position: "absolute" }}>
        <MenuScreen
          navigate={navigateToScreen}
          handleMenuselection={handleMenuselection}
          shouldCloseMenu={shouldCloseMenu}
          handleRightButton={handleRightButton}
          isLogedIn={isLogedIn}
          appNavigate={navigate}
          handleLogout={handleLogoutMenu}
          handleExit={handleExit}
        />
      </div>
      <div
        style={{
          position: "absolute",
          // width: "100vw",
          // height: "100vh",
          // background: "yellow",
        }}
      >
        <ModalScreen
          shouldShowError={shouldShowModal}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          onClick={modalOKButtonHandler}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div>
    </div>
  );
};

export default DeleteProfile;